import _classCallCheck from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { getter } from 'property-expr';
var prefixes = {
  context: '$',
  value: '.'
};
export function create(key, options) {
  return new Reference(key, options);
}
var Reference = /*#__PURE__*/function () {
  function Reference(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Reference);
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    var prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && getter(this.path, true);
    this.map = options.map;
  }
  return _createClass(Reference, [{
    key: "getValue",
    value: function getValue(value, parent, context) {
      var result = this.isContext ? context : this.isValue ? value : parent;
      if (this.getter) result = this.getter(result || {});
      if (this.map) result = this.map(result);
      return result;
    }
    /**
     *
     * @param {*} value
     * @param {Object} options
     * @param {Object=} options.context
     * @param {Object=} options.parent
     */
  }, {
    key: "cast",
    value: function cast(value, options) {
      return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
  }, {
    key: "resolve",
    value: function resolve() {
      return this;
    }
  }, {
    key: "describe",
    value: function describe() {
      return {
        type: 'ref',
        key: this.key
      };
    }
  }, {
    key: "toString",
    value: function toString() {
      return "Ref(".concat(this.key, ")");
    }
  }], [{
    key: "isRef",
    value: function isRef(value) {
      return value && value.__isYupRef;
    }
  }]);
}(); // @ts-ignore
export { Reference as default };
Reference.prototype.__isYupRef = true;